"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tokenizer = void 0;
var is_nil_1 = require("../../utils/is-nil");
var event_trigger_1 = require("../../utils/event-trigger");
var extend_1 = require("../../utils/extend");
var Tokenizer = function (target) {
    return /** @class */ (function (_super) {
        __extends(Tokenizer, _super);
        function Tokenizer() {
            var constructorArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                constructorArgs[_i] = arguments[_i];
            }
            var _this = _super.apply(this, constructorArgs) || this;
            var tokenizer = _this.options.get('tokenizer');
            if (!is_nil_1.isNil(tokenizer)) {
                _this.tokenizer = tokenizer;
            }
            return _this;
        }
        Tokenizer.prototype.binding = function (select, container) {
            _super.prototype.binding.call(this, select, container);
            this.search = select.dropdown['search']
                || select.selection['search']
                || select.element.querySelector('.select2-search__field');
        };
        Tokenizer.prototype.query = function (params, callback) {
            var _this = this;
            var select = function (data) {
                _this.trigger('select', { data: data });
            };
            var createAndSelect = function (data) {
                // Normalize the data object so we can use it for checks
                var item = _this.normalizeItem(data);
                // Check if the data object already exists as a tag
                // Select it if it doesn't
                var existingOptions = Array
                    .from(_this.core.element.querySelectorAll('option'))
                    .filter(function (op) { return op.value === item.id; });
                // If an existing option wasn't found for it, create the option
                if (!existingOptions.length) {
                    var option = _this.option(item);
                    option.setAttribute('data-select2-tag', 'true');
                    _this.removeOldTags();
                    _this.addOptions([option]);
                }
                // Select the item, now that we know there is an option for it
                select(item);
            };
            params.term = params.term || '';
            var tokenData = this.tokenizer(params, this.options, createAndSelect);
            if (tokenData.term !== params.term) {
                // Replace the search term if we have the search box
                if (this.search) {
                    this.search.value = tokenData.term;
                    event_trigger_1.eventTrigger(this.search, 'focus');
                }
                params.term = tokenData.term;
            }
            _super.prototype.query.call(this, params, callback);
        };
        Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
            var separators = options.get('tokenSeparators') || [];
            var term = params.term;
            var i = 0;
            var createTag = this.createTag || function (_params) {
                return {
                    id: _params.term,
                    text: _params.term
                };
            };
            while (i < term.length) {
                var termChar = term[i];
                if (separators.indexOf(termChar) === -1) {
                    i++;
                    continue;
                }
                var part = term.substr(0, i);
                var partParams = extend_1.extend({}, params, {
                    term: part
                });
                var data = createTag(partParams);
                if (data == null) {
                    i++;
                    continue;
                }
                callback(data);
                // Reset the term to not include the tokenized portion
                term = term.substr(i + 1) || '';
                i = 0;
            }
            return { term: term };
        };
        return Tokenizer;
    }(target));
};
exports.Tokenizer = Tokenizer;
//# sourceMappingURL=tokenizer.js.map